module.exports = __webpack_public_path__ + "img/activeindoorlogocolortrans.4d4331d6.png";